module.exports =
{
    FILE_SIZE: 10000,
    
}